module.exports = __webpack_public_path__ + "static/img/prod-fashion1.f12c7315.jpg";